import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex min-h-screen rounded-2xl m-1" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50"
}
const _hoisted_3 = {
  key: 1,
  class: "fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-[#157813] text-white px-6 py-3 rounded-lg shadow-lg flex items-center space-x-2 transition-opacity duration-300 z-50"
}
const _hoisted_4 = { class: "container mx-auto px-4 py-6 w-full overflow-x-auto" }
const _hoisted_5 = { class: "flex flex-col md:flex-row gap-4 w-full" }
const _hoisted_6 = { class: "md:w-72 w-full flex-shrink-0 bg-gray-100 rounded-lg shadow-sm border-gray-200 p-4 md:p-5 md:mr-10" }
const _hoisted_7 = { class: "space-y-4 text-black" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "w-full lg:w-3/4 shadow-xl md:px-8 px-4 py-6 relative" }
const _hoisted_10 = { class: "absolute top-2 right-3" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = {
  key: 0,
  class: "absolute right-0 mt-2 w-48 bg-white shadow-md rounded-lg z-10"
}
const _hoisted_13 = {
  id: "content",
  class: "m-6"
}
const _hoisted_14 = { class: "mb-8" }
const _hoisted_15 = { class: "text-4xl font-bold text-black" }
const _hoisted_16 = { class: "text-gray-500 text-sm mt-2 mx-3" }
const _hoisted_17 = { class: "text-gray-500 text-sm mt-2 mx-3" }
const _hoisted_18 = {
  id: "metadata",
  class: "mb-8"
}
const _hoisted_19 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_20 = { class: "bg-white border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow" }
const _hoisted_21 = { class: "font-bold text-black" }
const _hoisted_22 = { class: "bg-white border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow" }
const _hoisted_23 = { class: "font-bold text-black" }
const _hoisted_24 = { class: "bg-white border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow" }
const _hoisted_25 = { class: "font-bold text-black" }
const _hoisted_26 = {
  id: "sql",
  class: "mb-8"
}
const _hoisted_27 = { class: "relative" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  id: "description",
  class: "mb-8"
}
const _hoisted_30 = { class: "text-black" }
const _hoisted_31 = {
  id: "rules",
  class: "mb-8"
}
const _hoisted_32 = { class: "mt-4 text-black space-y-4" }
const _hoisted_33 = { class: "mt-2 pl-4 list-disc" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "mt-2 pl-4 list-disc" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  id: "features",
  class: "mb-8 p-6 bg-white rounded-xl shadow-md"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "flex flex-wrap gap-3" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "relative z-10" }
const _hoisted_42 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_43 = {
  id: "Inferences",
  class: "mb-8 p-6 bg-white rounded-xl shadow-md"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 0,
  class: "text-lg font-semibold text-gray-700 mb-3"
}
const _hoisted_46 = { class: "flex flex-wrap gap-3" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "relative z-10" }
const _hoisted_49 = {
  key: 0,
  class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 z-10 whitespace-nowrap"
}
const _hoisted_50 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_51 = {
  id: "mentioned",
  class: "mb-8 p-6 bg-white rounded-xl shadow-md"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 0,
  class: "text-lg font-semibold text-gray-700 mb-3"
}
const _hoisted_54 = { class: "flex flex-wrap gap-3" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "relative z-10" }
const _hoisted_57 = {
  key: 0,
  class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 z-10 whitespace-nowrap"
}
const _hoisted_58 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_59 = {
  key: 0,
  id: "query-relationships",
  class: "mb-8"
}
const _hoisted_60 = { class: "bg-white border border-gray-200 rounded-xl p-6 shadow-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")!
  const _component_Database = _resolveComponent("Database")!
  const _component_FileText = _resolveComponent("FileText")!
  const _component_Book = _resolveComponent("Book")!
  const _component_ShieldCheck = _resolveComponent("ShieldCheck")!
  const _component_Settings = _resolveComponent("Settings")!
  const _component_ClipboardList = _resolveComponent("ClipboardList")!
  const _component_Tags = _resolveComponent("Tags")!
  const _component_QueryFlowGraph = _resolveComponent("QueryFlowGraph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoadingIndicator, {
            title: "Loading query details...",
            subtitle: "Fetching query information and metadata",
            status: "Processing request"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showToast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M5 13l4 4L19 7"
            })
          ], -1),
          _createElementVNode("span", null, "Copied to clipboard!", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("aside", _hoisted_6, [
          _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "text-xl font-bold text-[#157813] mb-6" }, "Navigation", -1)),
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#metadata",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.scrollToSection('metadata')), ["prevent"]))
              }, [
                _createVNode(_component_Database, { class: "w-5 h-5" }),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _cache[14] || (_cache[14] = _createElementVNode("span", null, "Metadata", -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#sql",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.scrollToSection('sql')), ["prevent"]))
              }, [
                _createVNode(_component_FileText, { class: "w-5 h-5" }),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "SQL Text", -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#description",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.scrollToSection('description')), ["prevent"]))
              }, [
                _createVNode(_component_Book, { class: "w-5 h-5" }),
                _cache[17] || (_cache[17] = _createTextVNode()),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "Description", -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#rules",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.scrollToSection('rules')), ["prevent"]))
              }, [
                _createVNode(_component_ShieldCheck, { class: "w-5 h-5" }),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _cache[20] || (_cache[20] = _createElementVNode("span", null, "Rules", -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#features",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.scrollToSection('features')), ["prevent"]))
              }, [
                _createVNode(_component_Settings, { class: "w-5 h-5" }),
                _cache[21] || (_cache[21] = _createTextVNode()),
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "Features", -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#Inferences",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.scrollToSection('Inferences')), ["prevent"]))
              }, [
                _createVNode(_component_ClipboardList, { class: "w-5 h-5" }),
                _cache[23] || (_cache[23] = _createTextVNode()),
                _cache[24] || (_cache[24] = _createElementVNode("span", null, "Inferred Tags", -1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#mentioned",
                class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.scrollToSection('mentioned')), ["prevent"]))
              }, [
                _createVNode(_component_Tags, { class: "w-5 h-5" }),
                _cache[25] || (_cache[25] = _createTextVNode()),
                _cache[26] || (_cache[26] = _createElementVNode("span", null, "Mentioned Tags", -1))
              ])
            ]),
            (_ctx.showRelationships)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("a", {
                    href: "#query-relationships",
                    class: "flex items-center space-x-2 hover:text-[#33dd1a]",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.scrollToSection('query-relationships')), ["prevent"]))
                  }, [...(_cache[27] || (_cache[27] = [
                    _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"w-5 h-5\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-4180b4e9><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 3v18h18\" data-v-4180b4e9></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7 12v6\" data-v-4180b4e9></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v10\" data-v-4180b4e9></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17 4v14\" data-v-4180b4e9></path></svg><span data-v-4180b4e9>Query Graph</span>", 2)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("main", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
                class: "bg-[#157813] hover:bg-[#3c8c2d] text-white rounded-xl font-bold px-3 py-2 md:mx-4 mb-12"
              }, " PDF/CSV "),
              (_ctx.isDropdownOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.downloadPdf && _ctx.downloadPdf(...args))),
                      class: "block w-full text-left px-4 py-2 hover:bg-gray-100 text-black"
                    }, " Download as PDF "),
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.exportToCsv && _ctx.exportToCsv(...args))),
                      class: "block w-full text-left px-4 py-2 hover:bg-gray-100 text-black"
                    }, " Export Query to CSV ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("header", _hoisted_14, [
              _createElementVNode("h1", _hoisted_15, " Query ID: " + _toDisplayString(_ctx.query?.id), 1),
              _createElementVNode("p", _hoisted_16, " Query Type: " + _toDisplayString(_ctx.getQueryTypeLabel(_ctx.query?.componentType)), 1),
              _createElementVNode("p", _hoisted_17, " Page Last Updated: " + _toDisplayString(_ctx.query?.RunTimestamp), 1)
            ]),
            _createElementVNode("section", _hoisted_18, [
              _cache[33] || (_cache[33] = _createElementVNode("h2", { class: "text-2xl font-semibold text-[#157813] mb-4" }, " Metadata ", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h3", _hoisted_21, [
                    _cache[29] || (_cache[29] = _createElementVNode("strong", null, "Author:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.query?.author), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h3", _hoisted_23, [
                    _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Start Date:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.query?.queryStartTime ? _ctx.query?.startDate : "N/A"), 1)
                  ])
                ]),
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "bg-white border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow" }, [
                  _createElementVNode("h3", { class: "font-bold text-black" }, [
                    _createElementVNode("strong", null, "Run Date:"),
                    _createTextVNode(" N/A ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h3", _hoisted_25, [
                    _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Run Count:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.query?.extraction), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_26, [
              _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "text-2xl font-semibold text-[#157813] mb-4" }, " SQL Text ", -1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("pre", {
                  class: "font-code w-full bg-gray-100 px-6 py-10 rounded border border-gray-200 text-sm text-black",
                  style: {"white-space":"pre-wrap","word-break":"break-word","overflow-x":"hidden"},
                  innerHTML: _ctx.formattedSQL
                }, null, 8, _hoisted_28),
                _createElementVNode("button", {
                  class: "absolute top-2 right-2 bg-white border border-gray-300 rounded p-1 shadow hover:bg-gray-50",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.copyQueryWithTimestamp && _ctx.copyQueryWithTimestamp(...args))),
                  title: "Copy query text, metadata, and timestamp"
                }, [...(_cache[34] || (_cache[34] = [
                  _createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-6 h-6 inline hover:fill-[#1aa818]\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-4180b4e9><g stroke-width=\"0\" data-v-4180b4e9></g><g stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4180b4e9></g><g data-v-4180b4e9><path d=\"M15.24 2H11.3458C9.58159 1.99999 8.18418 1.99997 7.09054 2.1476C5.96501 2.29953 5.05402 2.61964 4.33559 3.34096C3.61717 4.06227 3.29833 4.97692 3.14701 6.10697C2.99997 7.205 2.99999 8.60802 3 10.3793V16.2169C3 17.725 3.91995 19.0174 5.22717 19.5592C5.15989 18.6498 5.15994 17.3737 5.16 16.312L5.16 11.3976L5.16 11.3024C5.15993 10.0207 5.15986 8.91644 5.27828 8.03211C5.40519 7.08438 5.69139 6.17592 6.4253 5.43906C7.15921 4.70219 8.06404 4.41485 9.00798 4.28743C9.88877 4.16854 10.9887 4.1686 12.2652 4.16867L12.36 4.16868H15.24L15.3348 4.16867C16.6113 4.1686 17.7088 4.16854 18.5896 4.28743C18.0627 2.94779 16.7616 2 15.24 2Z\" fill=\"#157813\" data-v-4180b4e9></path><path d=\"M6.6001 11.3974C6.6001 8.67119 6.6001 7.3081 7.44363 6.46118C8.28716 5.61426 9.64481 5.61426 12.3601 5.61426H15.2401C17.9554 5.61426 19.313 5.61426 20.1566 6.46118C21.0001 7.3081 21.0001 8.6712 21.0001 11.3974V16.2167C21.0001 18.9429 21.0001 20.306 20.1566 21.1529C19.313 21.9998 17.9554 21.9998 15.2401 21.9998H12.3601C9.64481 21.9998 8.28716 21.9998 7.44363 21.1529C6.6001 20.306 6.6001 18.9429 6.6001 16.2167V11.3974Z\" fill=\"#157813\" data-v-4180b4e9></path></g></svg>", 1)
                ]))])
              ])
            ]),
            _createElementVNode("section", _hoisted_29, [
              _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "text-2xl font-semibold text-[#157813] mb-4" }, " Description ", -1)),
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.query?.description?.main), 1)
            ]),
            _createElementVNode("section", _hoisted_31, [
              _cache[39] || (_cache[39] = _createElementVNode("h2", { class: "text-2xl font-semibold text-[#157813] mb-4" }, "Rules", -1)),
              _createElementVNode("ul", _hoisted_32, [
                _createElementVNode("li", null, [
                  _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Inclusion Rules:", -1)),
                  _createElementVNode("ul", _hoisted_33, [
                    (_ctx.formattedInclusionRules.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formattedInclusionRules, (rule, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: 'inclusion-' + index
                          }, _toDisplayString(rule), 1))
                        }), 128))
                      : (_openBlock(), _createElementBlock("li", _hoisted_34, "N/A"))
                  ])
                ]),
                _createElementVNode("li", null, [
                  _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Exclusion Rules:", -1)),
                  _createElementVNode("ul", _hoisted_35, [
                    (_ctx.formattedExclusionRules.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formattedExclusionRules, (rule, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: 'exclusion-' + index
                          }, _toDisplayString(rule), 1))
                        }), 128))
                      : (_openBlock(), _createElementBlock("li", _hoisted_36, "N/A"))
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_37, [
              _cache[40] || (_cache[40] = _createStaticVNode("<div class=\"flex items-center gap-3 mb-6\" data-v-4180b4e9><h2 class=\"text-2xl font-semibold text-[#157813]\" data-v-4180b4e9>Features</h2><div class=\"relative group\" data-v-4180b4e9><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5 text-gray-400 cursor-help\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-4180b4e9><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8.228 9c.549-1.165 2.03-2 3.772-2 \n                        2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093\n                        m0 3h.01M12 21a9 9 0 100-18 9 9 0 000 18z\" data-v-4180b4e9></path></svg><div class=\"absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-4 py-2 bg-black rounded-lg invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-300 w-64 z-10\" data-v-4180b4e9><p class=\"text-white text-sm\" data-v-4180b4e9> Numerical calculations, attributes, groupings explicitly typed by the user </p><div class=\"absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-black rotate-45\" data-v-4180b4e9></div></div></div></div>", 1)),
              (_ctx.query?.features && _ctx.query.features.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.query.features, (tag) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: tag,
                          class: "relative group"
                        }, [
                          _createElementVNode("span", {
                            class: "relative overflow-hidden rounded-lg px-4 py-2 text-sm font-medium transition-all duration-300 hover:shadow-lg hover:scale-105 hover:-translate-y-0.5 cursor-pointer transform border-gray-300 bg-gray-50 text-black hover:ring-2 hover:ring-opacity-50 hover:ring-gray-300",
                            onClick: ($event: any) => (_ctx.goToFeatureScreen(tag))
                          }, [
                            _createElementVNode("span", _hoisted_41, _toDisplayString(tag), 1)
                          ], 8, _hoisted_40)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_42, "N/A"))
            ]),
            _createElementVNode("section", _hoisted_43, [
              _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"flex items-center gap-3 mb-6\" data-v-4180b4e9><h2 class=\"text-2xl font-semibold text-[#157813]\" data-v-4180b4e9> Inferred Tags </h2><div class=\"relative group\" data-v-4180b4e9><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5 text-gray-500 cursor-help\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-4180b4e9><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8.228 9c.549-1.165 \n                        2.03-2 3.772-2 2.21 0 4 1.343 4 3 \n                        0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093\n                        m0 3h.01M12 21a9 9 0 100-18 9 9 0 000 18z\" data-v-4180b4e9></path></svg><div class=\"absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity w-64 text-center\" data-v-4180b4e9> Automatically inferred tags based on query analysis <div class=\"absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45\" data-v-4180b4e9></div></div></div></div>", 1)),
              (_ctx.groupedInferred.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedInferred, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.category + group.tags.join('-'),
                        class: "mb-6"
                      }, [
                        (group.category)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_45, _toDisplayString(group.category), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tags, (tag) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tag,
                              class: "relative group"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass([_ctx.getTagClassByCategory(group.category), "inline-flex items-center"]),
                                onClick: ($event: any) => (_ctx.goToInferenceScreen(tag))
                              }, [
                                _createElementVNode("span", _hoisted_48, _toDisplayString(tag), 1)
                              ], 10, _hoisted_47),
                              (group.category)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _createTextVNode(_toDisplayString(group.category) + " ", 1),
                                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45" }, null, -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, "N/A"))
            ]),
            _createElementVNode("section", _hoisted_51, [
              _cache[44] || (_cache[44] = _createStaticVNode("<div class=\"flex items-center gap-3 mb-6\" data-v-4180b4e9><h2 class=\"text-2xl font-semibold text-[#157813]\" data-v-4180b4e9> Mentioned Tags </h2><div class=\"relative group\" data-v-4180b4e9><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-5 w-5 text-gray-500 cursor-help\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-4180b4e9><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8.228 9c.549-1.165 \n                        2.03-2 3.772-2 2.21 0 4 1.343 4 3 \n                        0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093\n                        m0 3h.01M12 21a9 9 0 100-18 9 9 0 000 18z\" data-v-4180b4e9></path></svg><div class=\"absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 w-64 text-center\" data-v-4180b4e9> Direct mentions of tables, fields, or conditions <div class=\"absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45\" data-v-4180b4e9></div></div></div></div>", 1)),
              (_ctx.groupedMentioned.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedMentioned, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.category + group.tags.join('-'),
                        class: "mb-6"
                      }, [
                        (group.category)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_53, _toDisplayString(group.category), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_54, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tags, (tag) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tag,
                              class: "relative group"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass([_ctx.getTagClassByCategory(group.category), "inline-flex items-center"]),
                                onClick: ($event: any) => (_ctx.goToMentionScreen(tag))
                              }, [
                                _createElementVNode("span", _hoisted_56, _toDisplayString(tag), 1)
                              ], 10, _hoisted_55),
                              (group.category)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _createTextVNode(_toDisplayString(group.category) + " ", 1),
                                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45" }, null, -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_58, "N/A"))
            ]),
            (_ctx.showRelationships)
              ? (_openBlock(), _createElementBlock("section", _hoisted_59, [
                  _cache[45] || (_cache[45] = _createElementVNode("h2", { class: "text-2xl font-semibold text-[#157813] mb-4" }, " Query Relationships ", -1)),
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_QueryFlowGraph, {
                      queries: _ctx.queries,
                      "current-query-id": _ctx.query?.id || ''
                    }, null, 8, ["queries", "current-query-id"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[46] || (_cache[46] = _createElementVNode("section", {
              id: "usage-stats",
              class: "mt-8"
            }, [
              _createElementVNode("h2", { class: "text-2xl font-semibold text-[#157813] mb-4" }, " Usage Statistics "),
              _createElementVNode("p", { class: "text-black" }, "Section in progress..")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}